/* unplugin-vue-components disabled */import script from "./PaidTableBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaidTableBlock.vue?vue&type=script&setup=true&lang=ts"

import "./PaidTableBlock.vue?vue&type=style&index=0&id=1a6bbc8e&scoped=true&lang=less"
import "./PaidTableBlock.vue?vue&type=style&index=1&id=1a6bbc8e&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a6bbc8e"]])

export default __exports__